/**
 * Renders one `application/ld+json` block per entry. Passing an array lets a
 * page declare all of its graphs in a single tag instead of stacking several
 * `<JsonLd>` elements.
 */
export function JsonLd({ data }: { data: unknown }) {
  const graphs = Array.isArray(data) ? data : [data];
  return (
    <>
      {graphs.map((graph, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(graph) }}
        />
      ))}
    </>
  );
}
